import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import BarColumn from './BarColumn';

const useStyles = makeStyles(theme => ({
  barContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: theme.spacing(4),
    marginBottom: theme.spacing(0.5),
    border: `1px solid ${theme.palette.divider}`,
    overflow: 'hidden'
  },
  benchBar: {
    backgroundColor: theme.palette.resourceAllocation.bench
  },
  overAllocationBar: {
    backgroundColor: theme.palette.resourceAllocation.overAllocated
  }
}));

const BarChart = memo(({ bench, overAllocation, maxValue, unitLabel }) => {
  const classes = useStyles();

  return (
    <Box className={classes.barContainer}>
      <BarColumn
        value={bench}
        maxValue={maxValue}
        className={classes.benchBar}
        dataQeId="bench"
      />
      <BarColumn
        value={overAllocation}
        maxValue={maxValue}
        className={classes.overAllocationBar}
        dataQeId="overAllocation"
      />
    </Box>
  );
});

BarChart.propTypes = {
  bench: PropTypes.number.isRequired,
  overAllocation: PropTypes.number.isRequired,
  maxValue: PropTypes.number.isRequired,
  unitLabel: PropTypes.string
};

export default BarChart;
